import { useNavigate } from 'react-router-dom'

import { Button } from 'components/ui/Button'

export const NotFoundPage = () => {
  /* --- Section 1: Hooks --- */
  const navigate = useNavigate()

  /* --- Section 4: Event Handlers --- */
  const handleBackToHome = () => {
    navigate('/')
  }

  /* --- Section 6: Render --- */
  return (
    <div className="athlete-app">
      <div className="athlete-error-container">
        <div className="athlete-error-content">
          <div className="athlete-error-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="var(--color-indigo)" strokeWidth="2" />
              <path d="M9 9l6 6M15 9l-6 6" stroke="var(--color-indigo)" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          <h2 className="athlete-error-title">404 - Page Not Found</h2>
          <p className="athlete-error-message">Oops! The page you&apos;re looking for doesn&apos;t exist.</p>
          <p className="athlete-error-hint">
            It looks like you may have taken a wrong turn. Let&apos;s get you back on track!
          </p>
          <Button className="not-found-primary-action" onClick={handleBackToHome} variant="primary">
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  )
}
